import { render, staticRenderFns } from "./TenderDescription.vue?vue&type=template&id=2915c308"
import script from "./TenderDescription.vue?vue&type=script&lang=js"
export * from "./TenderDescription.vue?vue&type=script&lang=js"
import style0 from "./TenderDescription.vue?vue&type=style&index=0&id=2915c308&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports